import React, { useContext, useState, useRef, useEffect } from "react";
import { ContentContext } from "../contexts/ContentContext";
import { FiGlobe, FiChevronDown } from "react-icons/fi";

const LANGS = [
    { code: "en", label: "English" },
    { code: "ru", label: "Русский" },
    { code: "ar", label: "العربية" },
];

export default function LanguageSelector({ dark = false }) {
    const { language, setLanguage } = useContext(ContentContext);
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const current = LANGS.find((l) => l.code === language) || LANGS[0];

    return (
        <div className="relative" ref={ref}>
            <button
                onClick={() => setOpen(!open)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition ${
                    dark
                        ? "text-navy-100 hover:bg-white/10"
                        : "text-navy-700 hover:bg-navy-50"
                }`}
            >
                <FiGlobe className="w-4 h-4" />
                <span>{current.label}</span>
                <FiChevronDown className={`w-4 h-4 transition ${open ? "rotate-180" : ""}`} />
            </button>
            {open && (
                <div className="absolute end-0 right-0 mt-2 w-40 bg-white rounded-lg shadow-soft border border-navy-100 overflow-hidden z-50">
                    {LANGS.map((l) => (
                        <button
                            key={l.code}
                            onClick={() => {
                                setLanguage(l.code);
                                setOpen(false);
                            }}
                            className={`w-full text-start px-4 py-2.5 text-sm transition ${
                                l.code === language
                                    ? "bg-gold-50 text-navy-900 font-semibold"
                                    : "text-navy-700 hover:bg-navy-50"
                            }`}
                        >
                            {l.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
